import PropTypes from 'prop-types'
import Skeleton from 'react-loading-skeleton'
import { Heading } from '../../../../components/ui/Heading'

export default function HiringInitiatives({
  measures_label,
  measures,
  isLoading
}) {
  return (
    <div className='rounded-lg border border-lightGrey bg-lightPaleGrey'>
      <div className='px-10 py-6'>
        <Heading className={'text-buttonSecondaryBlue'} level={4}>
          {isLoading ? <Skeleton width={200} /> : measures_label}
        </Heading>
      </div>
      <div className='flex flex-col gap-y-4 border-t border-lightGrey p-6'>
        {isLoading && <Skeleton count={3} />}
        {Array.isArray(measures) &&
          measures?.map((measureText, index) => (
            <div
              key={`${index}-${measureText}`}
              className='flex flex-row items-center'
            >
              <svg
                className='mr-2 flex-shrink-0'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M9.58011 1.07653C9.88578 1.22635 10.0522 1.56326 9.98545 1.89706L9.16486 5.99998H13.25C13.5437 5.99998 13.8103 6.17134 13.9323 6.43845C14.0542 6.70555 14.0091 7.01927 13.8168 7.24117L7.31678 14.7412C7.09383 14.9984 6.72559 15.0733 6.41991 14.9234C6.11424 14.7736 5.94781 14.4367 6.01458 14.1029L6.83516 9.99998H2.75001C2.45637 9.99998 2.18974 9.82862 2.06777 9.56151C1.9458 9.2944 1.99093 8.98068 2.18324 8.75878L8.68324 1.25878C8.90619 1.00153 9.27444 0.926698 9.58011 1.07653Z'
                  fill='#4461D4'
                />
              </svg>

              <p className='text-base font-normal text-darkBlack'>
                {measureText}
              </p>
            </div>
          ))}
      </div>
    </div>
  )
}

HiringInitiatives.propTypes = {
  measures_label: PropTypes.string.isRequired,
  measures: PropTypes.arrayOf(PropTypes.string).isRequired
}
